<template>
    <div class="modal fade" id="protectionPlanDetailModal" ref="protectionPlanDetailModal" tabindex="-1"
        aria-labelledby="protectionPlanDetailModal" aria-hidden="true" data-bs-backdrop="static"
        data-bs-keyboard="false">
        <!-- protectionPlanDetails.plans.length use for innerWidth adjustment -->
        <div class="modal-dialog modal-dialog-centered mobile:!px-0 tablet:!px-3 !my-0 h-full mobile:!max-w-full tablet:!max-w-[90%]"
            :class="[protectionPlanDetails.plans.length === 1 ? 'laptop:!max-w-[45%] desktop:!max-w-[40%] largeDesktop:!max-w-[40%]' : '',
            protectionPlanDetails.plans.length === 2 ? 'laptop:!max-w-[80%] desktop:!max-w-[70%]' : '']">
            <div class="modal-content select-none">
                <div class="modal-body !p-3 !pb-5" v-if="protectionPlanDetails">
                    <!-- modal header  -->
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
                        </button>
                        <div class="relative rounded-lg overflow-hidden min-h-[80px] w-full">
                            <div class="absolute left-0 top-0 w-full h-full z-10">
                                <img src="../../assets/images/profile-bg-2.png" alt="Background"
                                    class="w-full mobile:h-full tablet:h-full object-cover">
                            </div>
                            <div
                                class="flex mobile:flex-col tablet:flex-row items-center justify-between relative z-20">
                                <div
                                    class="flex flex-col justify-center mobile:pl-3 mobile:p-1 tablet:p-3 mobile:w-full tablet:w-[50%] h-full">
                                    <div class="flex justify-start items-center gap-1">
                                        <div class="w-1.5 h-1.5 rounded-full bg-blueLight-100"></div>
                                        <div class="w-6 h-1.5 rounded-full bg-blueLight-100"></div>
                                        <p class="text-lg font-bold font-roboto pl-2 m-0 text-blueLight-100">New Bundle
                                        </p>
                                    </div>
                                    <h4 class="text-lg largeDesktop:text-xl m-0 text-black-100">{{
                                        protectionPlanDetails.bundle_name }}
                                    </h4>
                                </div>
                                <div
                                    class="flex flex-col justify-center mobile:items-start tablet:items-end mobile:py-1 tablet:py-2 mobile:pl-3 tablet:pl-0 tablet:pr-10 laptop:pr-14 mobile:w-full tablet:w-[50%] h-full">
                                    <div class="text-left">
                                        <h4 v-if="protectionPlanDetails.months > 1"
                                            class="font-roboto mobile:text-[16px] tablet:text-[18px] m-0 text-red-500">
                                            {{
                                                protectionPlanDetails.months }} months plan</h4>
                                        <h4 v-else
                                            class="font-roboto mobile:text-[16px] tablet:text-[18px] m-0 text-red-500">
                                            {{
                                                protectionPlanDetails.months }} month plan</h4>

                                        <h2
                                            class="font-roboto mobile:text-[20px] tablet:text-[30px] font-bold mb-0 text-gray-900">
                                            ${{
                                                $helper.formatAmount(protectionPlanDetails.amount) }}<span
                                                class="text-lg">/mo</span></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- modal header end  -->
                    <!-- slider box  -->
                    <div class="relative">
                        <div v-if="isCarouselLoading" class="h-full w-full absolute top-0 left-0 z-50 bg-white"></div>
                        <bundleSlider ref="childComp" :length="protectionPlanDetails.plans.length">
                            <Slide v-for="(item, index) in protectionPlanDetails.plans" :key="index">
                                <bundleDetailCard :plan="item" :modalKey="modalKey" />
                            </Slide>
                        </bundleSlider>
                    </div>
                    <div class="mobile:py-1 tablet:py-2 pt-3 border-t border-gray-200">
                        <span v-if="protectionPlanDetails.quantity == null || protectionPlanDetails.quantity == 0"
                            @click="updateCounter('increment')"
                            class="w-max group px-3 py-1.5 flex justify-center items-center mx-auto gap-1 text-base rounded-full cursor-pointer border-[1px] !border-secondary-100 text-secondary-100 hover:bg-secondary-100 hover:text-white">
                            <img src="../../assets/images/cart-check.png"
                                class="w-7 h-7 object-contain group-hover:hidden" alt="icon">
                            <img src="../../assets/images/cart-check-white.png"
                                class="w-7 h-7 object-contain !hidden group-hover:!block" alt="icon">
                            Select this bundle
                        </span>
                        <div v-else class="flex w-full justify-center items-center gap-4">
                            <quantityCounter v-if="protectionPlanDetails.is_show_quantity == 1"
                                :quantity="protectionPlanDetails.quantity" @update-counter="updateCounter" />
                            <button v-else type="button" @click="updateCounter('remove')"
                                class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-[#F67280] hover:bg-[#F67280]">
                                <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                                    class="w-7 h-7 group-hover:hidden">
                                <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                                    class="w-7 h-7 hidden group-hover:!block">
                            </button>
                            <span type="button"
                                class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 bg-secondary-100 text-white">
                                <img src="../../assets/images/cart-check-white.png" alt="Cart Icon" class="w-7 h-7">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import quantityCounter from '../partialComponent/quantityCounter.vue';
import bundleDetailCard from '../../components/protectionPlansCards/bundleDetailCard.vue';
import bundleSlider from '../../components/protectionPlansCards/bundleSlider.vue';
import { mapActions, mapGetters } from "vuex";
import { Modal } from "bootstrap";
import { Slide } from 'vue3-carousel';

export default {
    computed: {
        ...mapGetters([
            "protectionPlanBundleDetailsCallBack",
            "cartUpdated",
            "bundleQuantityUpdated"
        ])
    },
    components: {
        quantityCounter,
        bundleDetailCard,
        bundleSlider,
        Slide
    },
    props: [],
    data() {
        return {
            protectionPlanDetails: { plans: [] },
            selectedPlan: {},
            quantity: 0,
            modalKey: 0,
            isCarouselLoading: false
        }
    },

    watch: {

        bundleQuantityUpdated: function (data) {
           this.protectionPlanDetails.quantity = this.quantity
        },
        protectionPlanBundleDetailsCallBack: function (data) {

            this.protectionPlanDetails = this.protectionPlanBundleDetailsCallBack

            if(this.protectionPlanBundleDetailsCallBack.is_single_plan_bundle != 1){

            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.protectionPlanDetailModal;

            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {

                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
                window.removeEventListener('resize', this.adjustPlanModalHeight);
                window.removeEventListener('orientationchange', this.adjustPlanModalHeight);
            });

            window.addEventListener('resize', this.adjustPlanModalHeight);
            window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            this.modalKey++;
            this.isCarouselLoading = true
            this.modal.show();
            setTimeout(() => {
                this.adjustPlanModalHeight();
                if (this.$refs.childComp?.$refs.carouselRef?.slideTo) {
                    this.$refs.childComp.$refs.carouselRef.slideTo(0); // 👈 force first slide
                }
                if (this.$refs.childComp) {
                    this.$refs.childComp.resetScroll();
                }
                setTimeout(() => {
                    this.isCarouselLoading = false
                }, 100);

            }, 100);
            this.$refs.protectionPlanDetailModal.addEventListener('hidden.bs.modal', this.onCartModalClose);

        }
        },
    },
    mounted() {
    },
    methods: {
        ...mapActions([
            "getProtectionPlanBundleDetails",
        ]),

        updateCounter(option) {
            this.quantity = JSON.parse(JSON.stringify(this.protectionPlanDetails.quantity))
       
            if (option == "increment") {
                this.quantity++
            } else if (option == "decrement") {
                if (this.quantity > 1) {
                    this.quantity--
                } else {
                    this.quantity = 0
                }
            } else {
                this.quantity = 0
            }
            // this.updateCart(option, {
            //     id: this.protectionPlanDetails.id,
            //     quantity: this.protectionPlanDetails.quantity,
            //     type: 'plan'
            // })


            this.$emit('event', option, {
                id: this.protectionPlanDetails.id,
                quantity:   this.quantity,
                type: 'bundle'
            }, 'bundle', 'update', this.protectionPlanDetails)

        },
        adjustPlanModalHeight() {
            const modalContent = this.$refs.protectionPlanDetailModal?.querySelector('.responsiveOreitationHeightAdjust');
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 400) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.4 - 40;
                } else if (vw < 1024) {
                    maxHeight = vh * 0.4 - 30;
                } else {
                    maxHeight = vh * 0.6 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },

        getDetails(plan) {
            this.getProtectionPlanBundleDetails({
                id: plan.id
            })
        },
        openCartModal(plan) {

            this.selectedPlan = plan
            this.getProtectionPlanBundleDetails({
                id: plan.id
            })
          
        }
    }

}
</script>
